import * as _ from 'lodash';

export const  isAllSelected = (currentPage, selected): boolean =>(
      _.difference(currentPage, selected)
        .length === 0
    )

  export const masterToggle = (currentPage, selectionModel): void => {
    if (isAllSelected(currentPage, selectionModel.selected)) {
      currentPage.forEach((user) => {
        if (selectionModel.isSelected(user)) {
            selectionModel.deselect(user);
        }
      });
    } else {
      currentPage.forEach((user) => {
        if (!selectionModel.isSelected(user)) {
            selectionModel.select(user);
        }
      });
    }
  }

  export const isPartiallySelected = (currentPage, selected): boolean => {
    const diff = _.difference(currentPage, selected).length;
    return (diff < currentPage?.length && diff > 0);
  }

  export const sortingDataAccessor = (data: any, sortHeaderId: string): string  => {
    if (typeof data[sortHeaderId] === 'string') {
      return data[sortHeaderId].toLocaleLowerCase();
    }
  
    return data[sortHeaderId];
  }
